/**
 * Agent 工具 / 技能在聊天系统消息中的中文展示名（与 node-server agent tools 对齐）
 */

export const TOOL_DISPLAY_LABELS: Record<string, string> = {
  /** 与 node TOOL_DEFINITIONS 对齐；避免「执行 + 执行命令」重复语义 */
  execute_command: 'SSH 即时命令',
  execute_background_command: 'SSH 后台长任务',
  execute_interactive_command: 'SSH 交互式会话',
  send_interactive_input: '交互会话输入',
  send_background_task_stdin: '后台任务标准输入',
  check_task_status: 'SSH 后台任务进度',
  list_running_tasks: '列出后台任务',
  web_search: '网络搜索',
  check_status: '服务器状态',
  inspect_database_credentials: '数据库凭据探测',
  read_file: '读取文件',
  list_directory: '列出目录',
  write_file: '写入文件',
  edit_file: '编辑文件',
};

export function getToolDisplayLabel(toolId: string | undefined | null): string {
  if (!toolId) return '';
  return TOOL_DISPLAY_LABELS[toolId] ?? toolId;
}

/**
 * 聊天里展示「哪个 Agent 在调哪个工具」：固定前缀 Agent（ReAct + SSH），并带上英文 tool id
 */
export function formatAgentToolLine(toolId: string | undefined | null): string {
  if (!toolId) return 'Agent · （未知工具）';
  const label = getToolDisplayLabel(toolId);
  if (label === toolId) return `Agent · ${toolId}`;
  return `Agent · ${label}（${toolId}）`;
}
